<template>
  <v-dialog max-width="600px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Upgrade Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <r-item-upgrade-mode :model.sync="mode"/>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="mode.id > 0">
            <v-text-field v-model.number="model.duration" label="Duration:" hide-details/>
          </v-col>
          <v-col cols="12" sm="5" md="5" v-if="mode.id > 0">
            <r-item-dropdown :model.sync="model.upgradeItem" label="Upgrade to:(optional)"/>
          </v-col>
        </v-row>
        <v-row dense v-if="mode.id > 0">
          <v-col cols="12" sm="6" md="6">
            <r-quest-dropdown :model.sync="model.questAllow" label="Quest Allow" :clearable="true"/>
          </v-col>
          <v-col cols="12" sm="6" md="6" v-if="mode.id === 1">
            <r-ad-placement-dropdown :model.sync="model.adPlacement" title="Ad Placement" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3" v-if="mode.id === 1">
          <v-col cols="12" sm="12" md="12">
            <r-currency-table :items="model.price" title="Price"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3" v-else-if="mode.id === 2">
          <v-col cols="12" sm="12" md="12">
            <r-item-upgrade-rule-table :items="model.rules" title="Rules"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3" v-else-if="mode.id === 3">
          <v-col cols="12" sm="12" md="12">
            <r-item-upgrade-rule-table :items="model.rules" title="Rules"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


import {ViewRules} from "@/common/ViewRules";
import {ItemUpgradeConfig} from "@/modules/redactor/models/item/upgrade/ItemUpgradeConfig";
import {ItemUpgradeMode} from "@/modules/redactor/models/item/upgrade/ItemUpgradeMode";

import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table.vue";
import RItemUpgradeMode from "@/modules/redactor/views/item/upgrade/r-item-upgrade-mode.vue";
import RItemUpgradeRuleTable from "@/modules/redactor/views/item/upgrade/r-item-upgrade-rule-table.vue";
import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown.vue";
import RQuestDropdown from "@/modules/redactor/views/quest/r-quest-dropdown.vue";
import RAdPlacementDropdown from "@/modules/redactor/views/ad-settings/placement/r-ad-placement-dropdown.vue";

export default {
  name: "r-item-upgrade-config",
  components: {RAdPlacementDropdown, RQuestDropdown, RItemDropdown, RItemUpgradeRuleTable, RItemUpgradeMode, RCurrencyTable},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemUpgradeConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  computed: {
    mode: {
      get: function () {
        return this.model ? this.model.mode : ItemUpgradeMode.DISABLED;
      },
      set: function (value) {
        this.model.mode = value;
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemUpgradeConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>